(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pygmalion-gifting-invitation"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-gift-tiles]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const chosen = [];
      const current = root.querySelector('[data-current]');
      if (current) chosen.push(current.dataset.productId);
      const cta = root.querySelector('.pygmalion-gifting__button');
      const status = root.querySelector('.pygmalion-gifting__status');
      const tiers = root.querySelector('[data-tiers]');
      const tierItems = tiers ? [...tiers.querySelectorAll('.pygmalion-gifting__tier')] : [];

      function refresh() {
        if (cta) {
          const url = new URL(cta.dataset.baseUrl, location.origin);
          if (chosen.length) url.searchParams.set('pyg_pairs', chosen.join(','));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          cta.href = url.href;
        }
        if (tiers && tierItems.length) {
          const step = Math.min(chosen.length, tierItems.length);
          tiers.style.setProperty('--tier-fill', (step / tierItems.length * 100) + '%');
          tierItems.forEach((item, index) => item.classList.toggle('is-active', index === step - 1));
        }
        if (status) {
          const names = [...root.querySelectorAll('[data-current], [aria-pressed="true"]')].map(node => node.dataset.name);
          status.hidden = names.length < 2;
          status.textContent = root.dataset.selectedLabel + ': ' + names.join(', ');
        }
      }

      if (cta && cta.hasAttribute('data-add-to-cart')) {
        const label = cta.querySelector('[data-cta-label]');
        const original = label ? label.textContent : '';
        cta.addEventListener('click', async event => {
          const variants = [...root.querySelectorAll('[data-current], [aria-pressed="true"]')].map(node => node.dataset.variantId).filter(Boolean);
          if (!variants.length) return;
          event.preventDefault();
          const drawer = document.querySelector('cart-drawer');
          const body = { items: variants.map(id => ({ id: Number(id), quantity: 1 })) };
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            body.sections = drawer.getSectionsToRender().map(section => section.id);
            body.sections_url = window.location.pathname;
          }
          cta.setAttribute('aria-busy', 'true');
          try {
            const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
            const response = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add');
            if (label) label.textContent = cta.dataset.addedLabel;
            setTimeout(() => { if (label) label.textContent = original; }, 3000);
            if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          } catch (error) {
            if (status) { status.hidden = false; status.textContent = error.message; }
          } finally {
            cta.removeAttribute('aria-busy');
          }
        });
      }

      root.querySelectorAll('a.pygmalion-gifting__pair[data-product-id]').forEach(link => {
        const button = document.createElement('button');
        [...link.attributes].forEach(attr => { if (attr.name !== 'href') button.setAttribute(attr.name, attr.value); });
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.append(...link.childNodes);
        link.replaceWith(button);
        button.addEventListener('click', () => {
          const id = button.dataset.productId;
          const at = chosen.indexOf(id);
          if (at > -1) chosen.splice(at, 1); else chosen.push(id);
          const active = chosen.includes(id);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('aria-label', (active ? root.dataset.removeLabel : root.dataset.addLabel) + ' ' + button.dataset.name);
          button.querySelector('.pygmalion-gifting__mark').textContent = active ? '✓' : '+';
          refresh();
        });
      });
      refresh();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pygmalion-product-tablescape"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const previewThemeId = new URL(location.href).searchParams.get('preview_theme_id');
    if (!previewThemeId) return;
    document.querySelectorAll('.pyg-product-tablescape__cta').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      link.href = url.href;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pygmalion-tablescape"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-table-intro]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const chosen = new Set();
      const cta = root.querySelector('.pyg-table-intro__cta');
      const status = root.querySelector('.pyg-table-intro__status');
      root.querySelectorAll('[data-product-id]').forEach(link => {
        const button = document.createElement('button');
        [...link.attributes].forEach(attr => { if (attr.name !== 'href') button.setAttribute(attr.name, attr.value); });
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.append(...link.childNodes);
        link.replaceWith(button);
        button.addEventListener('click', () => {
          const id = button.dataset.productId;
          if (chosen.has(id)) chosen.delete(id); else chosen.add(id);
          const active = chosen.has(id);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('aria-label', (active ? root.dataset.removeLabel : root.dataset.addLabel) + ' ' + button.dataset.name);
          button.querySelector('.pyg-table-intro__mark').textContent = active ? '×' : '+';
          const url = new URL(cta.dataset.baseUrl, location.origin);
          if (chosen.size) url.searchParams.set('pyg_pairs', [...chosen].join(','));
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          cta.href = url.href;
          status.hidden = chosen.size === 0;
          status.textContent = root.dataset.selectedLabel + ': ' + [...root.querySelectorAll('[aria-pressed="true"]')].map(node => node.dataset.name).join(', ');
        });
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
